/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityCustomTag } from './FacilityCustomTag';
import {
    FacilityCustomTagFromJSON,
    FacilityCustomTagFromJSONTyped,
    FacilityCustomTagToJSON,
} from './FacilityCustomTag';

/**
 * 
 * @export
 * @interface FindAllFacilityCustomTags200Response
 */
export interface FindAllFacilityCustomTags200Response {
    /**
     * 
     * @type {Array<FacilityCustomTag>}
     * @memberof FindAllFacilityCustomTags200Response
     */
    data?: Array<FacilityCustomTag>;
}

/**
 * Check if a given object implements the FindAllFacilityCustomTags200Response interface.
 */
export function instanceOfFindAllFacilityCustomTags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllFacilityCustomTags200ResponseFromJSON(json: any): FindAllFacilityCustomTags200Response {
    return FindAllFacilityCustomTags200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityCustomTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityCustomTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FacilityCustomTagFromJSON)),
    };
}

export function FindAllFacilityCustomTags200ResponseToJSON(value?: FindAllFacilityCustomTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FacilityCustomTagToJSON)),
    };
}

